<template>
	<b-modal ref="modal" :title="title" :size="modalSize" class="modal-primary" @hidden="clearModalData">
		<b-row>
			<b-col>
				<b-card header="Dodajanje lokacije">
					<loading :active.sync="addHotelLocationButton.progress" 
						:is-full-page="false"></loading>
					<b-row>
						<b-col>
							<b-form-group
								:invalid-feedback="invalidFeedback_title"
								:state="state_title">
									<b-row>
										<b-col cols=11>
											<b-form-input :disabled="formDisabled" v-model="newHotelLokacija.title" id="input-title1" type="text"></b-form-input>
										</b-col>
										<b-col cols=1>
											<b-button ref="hotelLokacijaAdd" :disabled="addHotelLocationButton.disabled || formDisabled || !state_title" :title="hotelLokacijaAddTitle" class="m-1" variant="primary" @click.stop="hotelLokacijaAdd_click()" size="sm">
												<i class="fa fa-plus"></i>
											</b-button>
										</b-col>
									</b-row>
							</b-form-group>
						</b-col>
					</b-row>
					<b-alert :variant="messageHotelLocationsAdd.type" :show="messageHotelLocationsAdd.text && messageHotelLocationsAdd.text !== ''">{{ messageHotelLocationsAdd.text }}</b-alert>
				</b-card>
			</b-col>
		</b-row>
		<b-row v-if="!formDisabled">
			<b-col>
				<b-card>
					<loading :active.sync="hotelLokacijeTable_props.isLoading" 
						:is-full-page="false"></loading>
					<div slot="header">
						Seznam lokacij
						<div class="card-actions">
							<b-link title="Osveži tabelo" @click.stop="hotelLokacijeTableRefresh_click" class="card-header-action btn-setting"><i class="icon-refresh"></i></b-link>
							<b-link title="Odstrani filtre" @click.stop="hotelLokacijeTableToggleFilter_click" class="card-header-action btn-setting"><i class="icon-close"></i></b-link>
						</div>
					</div>
					<div v-show="messageHotelLocationsTable.text === null">
						<b-table
							ref="hotelLokacijeTable"
							responsive="sm"
							striped
							show-empty
							hover
							:empty-text="hotelLokacijeTable_props.empty_text"
							:empty-filtered-text="hotelLokacijeTable_props.empty_filtered_text"
							:sort-desc="true"
							:fields="hotelLokacijeTable_props.fields"
							:current-page="hotelLokacijeTable_props.page"
							:per-page="hotelLokacijeTable_props.size"
							:items="hotelLokacijeTable_items"
							@row-clicked="hotelLokacijeTable_rowClicked">
							<template slot="top-row">
								<td></td>
								<td><b-form-input v-model="hotelLokacijeTable_props.inputFilter.title" type="text" @input="hotelLokacijeTableTextFilter_change"/></td>
								<td></td>
								<td></td>
							</template>
							<template slot="status" slot-scope="data">
								<b-badge :variant="hotelLokacijaStatus(data.item).variant" :class="hotelLokacijaStatus(data.item).class" :title="hotelLokacijaStatus(data.item).title"> {{ hotelLokacijaStatus(data.item).label }}</b-badge>
							</template>
							<template slot="actions" slot-scope="data">
								<b-button v-if="data.item.hotel_hrambe_on_location && data.item.hotel_hrambe_on_location.length === 0" title="Odstrani lokacjio" ref="hotelHrambaEdit" class="m-1 seznamHotelHrambIconStyle" variant="danger" @click.stop="hotelLokacijaRemove_click(data.item)" size="sm">
									<i class="fa fa-remove"></i>
							</b-button>
							</template>
						</b-table>
						<nav class="nav">
							<b-row aligin->
								<b-col>
									<b-pagination :total-rows="hotelLokacijeTable_props.total" :per-page="hotelLokacijeTable_props.size" v-model="hotelLokacijeTable_props.page" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
								</b-col>
								<b-col>
									<a class="page-link rows_total">Št. vrstic: {{ hotelLokacijeTable_props.total }}</a>
								</b-col>
								<b-col>
									<b-form-select v-model="hotelLokacijeTable_props.size" :options="hotelLokacijeTable_props.options_numRowsOnPage"></b-form-select>
								</b-col>
							</b-row>
						</nav>
					</div>
					<b-alert :variant="messageHotelLocationsTable.type" :show="messageHotelLocationsTable.text && messageHotelLocationsTable.text !== ''">{{ messageHotelLocationsTable.text }}</b-alert>
					<b-alert :variant="messageHotelLocationsRemove.type" :show="messageHotelLocationsRemove.text && messageHotelLocationsRemove.text !== ''">{{ messageHotelLocationsRemove.text }}</b-alert>
				</b-card>
			</b-col>
		</b-row>
		<b-alert :variant="message.type" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
		<template slot="modal-footer" slot-scope="{ cancel }">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button style="margin-right:5px;" variant="secondary" @click="cancel()">Prekliči</b-button>
						<b-button variant="primary" @click.stop="onOkModal()">Zapri</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
	</b-modal>
</template>

<script>
import service from '@/service';
import settings from '@/settings.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
	name: 'hotel-lokacije-modal',
	components: {
		Loading
	},
	methods: {
		showModal: function (mode) {
			/*
				mode 1 => Normal
			*/
			this.mode = mode;
			this.initModal();
		},
		initModal: function () {
			if (this.mode === this.mode_NORMAL1) {
				this.title = 'Lokacije';
			} else {
				this.mode = this.mode_UNKNOWN0;
				this.title = 'Neznan način';
			}
			this.$refs.modal.show();
		},
		onOkModal: function () {
			this.$refs.modal.hide();
		},
		clearModalData: function () {
			this.title = '';
			this.addLocation_stopProgress();
			this.hideAlert();
			this.hideAlert('messageHotelLocationsTable');
			this.hideAlert('messageHotelLocationsAdd');
			this.hideAlert('messageHotelLocationsRemove');
			this.mode = this.mode_UNKNOWN0;
			this.newHotelLokacija = {
				id: 0,
				title: null
			};
			this.hotelLokacijeTableToggleFilters();
			this.hotelLokacijeTable_props.empty_text = '';
			this.hotelLokacijeTable_props.empty_filtered_text = 'Ni zadetkov';
			this.hotelLokacijeTable_props.page = 1;
			this.hotelLokacijeTable_props.size = 10;
			this.hotelLokacijeTable_props.total = 0;
			this.hotelLokacijeTable_props.isLoading = false;
			this.hotelLokacijeTable_props.textFilterTimeout = null;
		},
		addLocation_startProgress: function () {
			this.addHotelLocation_isLoading = true;
			this.addHotelLocationButton.disabled = true;
			this.addHotelLocationButton.progress = true;
		},
		addLocation_stopProgress: function () {
			this.addHotelLocation_isLoading = false;
			this.addHotelLocationButton.disabled = false;
			this.addHotelLocationButton.progress = false;
		},
		showAlert: function (alert) {
			let targetMessage = this.message;
			if (alert.target && alert.target === 'messageHotelLocationsAdd') {
				targetMessage = this.messageHotelLocationsAdd;
			} else if (alert.target && alert.target === 'messageHotelLocationsTable') {
				targetMessage = this.messageHotelLocationsTable;
			} else if (alert.target && alert.target === 'messageHotelLocationsRemove') {
				targetMessage = this.messageHotelLocationsRemove;
			}
			if (alert.message && alert.type && alert.seconds) {
				targetMessage.type = alert.type;
				targetMessage.text = alert.message;
				setTimeout(() => {
					this.hideAlert(alert.target);
				}, alert.seconds * 1000);
			} else if (alert.message && alert.type) {
				targetMessage.type = alert.type;
				targetMessage.text = alert.message;
			} else if (alert.message) {
				targetMessage.type = 'primary';
				targetMessage.text = alert.message;
			} else {
				targetMessage.type = null;
				targetMessage.text = null;
			}
		},
		hideAlert: function (target) {
			let targetMessage = this.message;
			if (target && target === 'messageHotelLocationsAdd') {
				targetMessage = this.messageHotelLocationsAdd;
			} else if (target && target === 'messageHotelLocationsTable') {
				targetMessage = this.messageHotelLocationsTable;
			} else if (target && target === 'messageHotelLocationsRemove') {
				targetMessage = this.messageHotelLocationsRemove;
			}
			targetMessage.type = null;
			targetMessage.text = null;
		},
		hotelLokacijeTableFilter_change: function (value) {
			this.$refs.hotelLokacijeTable.refresh();
		},
		hotelLokacijeTableTextFilter_change: function (value) {
			if (this.hotelLokacijeTable_props.textFilterTimeout !== null) {
				clearTimeout(this.hotelLokacijeTable_props.textFilterTimeout);
			}
			this.hotelLokacijeTable_props.textFilterTimeout = setTimeout(() => {
				this.$refs.hotelLokacijeTable.refresh();
			}, settings.filterTimeoutLength);
		},
		hotelLokacijeTableRefresh_click: function () {
			this.$refs.hotelLokacijeTable.refresh();
		},
		hotelLokacijeTableToggleFilter_click: function () {
			this.hotelLokacijeTableToggleFilters();
			this.$refs.hotelLokacijeTable.refresh();
		},
		hotelLokacijeTableToggleFilters: function () {
			this.hotelLokacijeTable_props.inputFilter.title = null;
		},
		hotelLokacijeTable_items: function (ctx) {
			this.hotelLokacijeTable_props.isLoading = true;
			this.hideAlert('messageHotelLocationsTable');
			return service.getHotelLokacijeFiltered(ctx, this.hotelLokacijeTable_props.inputFilter)
				.then(responseData => {
					this.hotelLokacijeTable_props.isLoading = false;
					if (responseData.message === 'success') {
						this.hotelLokacijeTable_props.empty_text = 'Ni vnosov';
						this.hotelLokacijeTable_props.total = responseData.items.total;
						return responseData.items.data;
					} else {
						this.showAlert({message: 'Neveljaven odziv strežnika!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable'});
						this.hotelLokacijeTable_props.empty_text = 'Napaka pri pridobivanju lokacij';
						this.hotelLokacijeTable_props.total = 0;
						console.error('Neveljaven odziv strežnika: ', responseData.message);
						return [];
					}
				})
				.catch(error => {
					this.hotelLokacijeTable_props.isLoading = false;
					if (error.response) {
						// Request made and server responded
						if (error.response.status === 400) {
							if (error.response.data.internalCode === 600) {
								this.showAlert({message: 'Neznana napaka na strežniku!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable'});
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 601) {
								this.showAlert({message: 'Napaka pri podatkovni bazi!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable'});
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 602) {
								this.showAlert({message: 'Uporabnik nima dostopa do hotela gum!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable'});
								console.error(error.response.data.message);
							} else if (error.response.data.internalCode === 603) {
								this.showAlert({message: 'Napaka pri validaciji na strežniku!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable'});
								console.error(error.response.data.message);
							} else {
								this.showAlert({message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable'});
								console.error(error.response.data.internalCode, error.response.data.message);
							}
						} else {
							this.showAlert({message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable'});
							console.error(error.response.status, error.response.data.message);
						}
					} else if (error.request) {
						// The request was made but no response was received
						this.showAlert({message: 'Napaka: strežnik se ni odzval!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable'});
						console.error('The request was made but no response was received:', error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						this.showAlert({message: 'Napaka pri pošiljanju zahteve na strežnik!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsTable'});
						console.error('Something happened in setting up the request that triggered an Error:', error.message);
					}
					this.hotelLokacijeTable_props.empty_text = 'Napaka pri pridobivanju lokacij';
					this.hotelLokacijeTable_props.total = 0;
					return [];
				});
		},
		hotelLokacijeTable_rowClicked: function (data) {
			console.log('row clicked', data.item);
		},
		hotelLokacijaAdd_click: function (data) {
			if (this.validateForm) {
				this.addLocation_startProgress();
				this.hideAlert('messageHotelLocationsAdd');
				service.hotelLokacijaEdit(this.newHotelLokacija)
					.then(responseData => {
						if (responseData.message === 'edited' || responseData.message === 'added') {
							this.showAlert({message: 'Lokacija ' + responseData.hotelLokacija.title + ' dodana!', type: this.ALERT_TYPE_SUCCESS, seconds: 2, target: 'messageHotelLocationsAdd'});
							this.newHotelLokacija = {
								id: 0,
								title: null
							};
							this.$refs.hotelLokacijeTable.refresh();
						} else {
							this.showAlert({message: 'Neveljaven odziv strežnika!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd'});
							console.error('Neveljaven response message: ' + responseData.message);
						}
						this.addLocation_stopProgress();
					})
					.catch(error => {
						this.addLocation_stopProgress();
						if (error.response) {
							// Request made and server responded
							if (error.response.status === 400) {
								if (error.response.data.internalCode === 600) {
									this.showAlert({message: 'Neznana napaka na strežniku!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd'});
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 601) {
									this.showAlert({message: 'Napaka pri podatkovni bazi!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd'});
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 602) {
									this.showAlert({message: 'Uporabnik nima dostopa do hotela gum!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd'});
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 603) {
									this.showAlert({message: 'Napaka pri validaciji na strežniku!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd'});
									console.error(error.response.data.message);
								} else if (error.response.data.internalCode === 607) {
									this.showAlert({message: 'Lokacija s tem nazivom že obstaja!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd'});
									console.error(error.response.data.message);
								} else {
									this.showAlert({message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd'});
									console.error(error.response.data.internalCode, error.response.data.message);
								}
							} else {
								this.showAlert({message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd'});
								console.error(error.response.status, error.response.data.message);
							}
						} else if (error.request) {
							// The request was made but no response was received
							this.showAlert({message: 'Napaka: strežnik se ni odzval!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd'});
							console.error('The request was made but no response was received:', error.request);
						} else {
							// Something happened in setting up the request that triggered an Error
							this.showAlert({message: 'Napaka pri pošiljanju zahteve na strežnik!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd'});
							console.error('Something happened in setting up the request that triggered an Error:', error.message);
						}
					});
			} else {
				this.showAlert({message: 'Nepravilno oblika naziva!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsAdd'});
				this.addLocation_stopProgress();
			}
		},
		hotelLokacijaStatus: function (item) {
			if (item.hotel_hrambe_on_location && item.hotel_hrambe_on_location.length > 0) {
				let title = '{ ';
				for (let hrambaOnLocattion of item.hotel_hrambe_on_location) {
					title += hrambaOnLocattion.id + ' ';
				}
				title += ' }';
				return {
					label: 'Zasedena(' + item.hotel_hrambe_on_location.length + ')',
					variant: 'danger',
					class: '',
					title: 'Lokacija je vezana na hrambe ' + title + '.'
				}
			} else {
				return {
					label: 'Prosta',
					variant: 'success',
					class: '',
					title: 'Lokacija je prosta'
				}
			}
		},
		hotelLokacijaRemove_click: function (item) {
			this.$bvModal.msgBoxConfirm('Želite izbrisati lokacijo ' + item.title + '?', {
				title: 'Potrdite brisanje lokacije',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					service.removeHotelLokacija(item.id)
						.then(responseData => {
							this.showAlert({message: 'Lokacija ' + responseData.hotelLokacija.title + ' odstranjena!', type: this.ALERT_TYPE_SUCCESS, seconds: 2, target: 'messageHotelLocationsRemove'});
							this.$refs.hotelLokacijeTable.refresh();
						})
						.catch(error => {
							this.addLocation_stopProgress();
							if (error.response) {
								// Request made and server responded
								if (error.response.status === 400) {
									if (error.response.data.internalCode === 600) {
										this.showAlert({message: 'Neznana napaka na strežniku!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove'});
										console.error(error.response.data.message);
									} else if (error.response.data.internalCode === 601) {
										this.showAlert({message: 'Napaka pri podatkovni bazi!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove'});
										console.error(error.response.data.message);
									} else if (error.response.data.internalCode === 602) {
										this.showAlert({message: 'Uporabnik nima dostopa do hotela gum!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove'});
										console.error(error.response.data.message);
									} else if (error.response.data.internalCode === 603) {
										this.showAlert({message: 'Napaka pri validaciji na strežniku!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove'});
										console.error(error.response.data.message);
									} else if (error.response.data.internalCode === 605) {
										this.showAlert({message: 'Lokacija ni prosta!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove'});
										console.error(error.response.data.message);
									} else if (error.response.data.internalCode === 606) {
										this.showAlert({message: 'Napaka pri brisanju lokacije!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove'});
										console.error(error.response.data.message);
									} else {
										this.showAlert({message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove'});
										console.error(error.response.data.internalCode, error.response.data.message);
									}
								} else {
									this.showAlert({message: 'Neznana napaka na strežniku (status: ' + error.response.status + ')!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove'});
									console.error(error.response.status, error.response.data.message);
								}
							} else if (error.request) {
								// The request was made but no response was received
								this.showAlert({message: 'Napaka: strežnik se ni odzval!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove'});
								console.error('The request was made but no response was received:', error.request);
							} else {
								// Something happened in setting up the request that triggered an Error
								this.showAlert({message: 'Napaka pri pošiljanju zahteve na strežnik!', type: this.ALERT_TYPE_ERROR, target: 'messageHotelLocationsRemove'});
								console.error('Something happened in setting up the request that triggered an Error:', error.message);
							}
						});
				}
			}).catch(err => {
				console.log(err);
			})
		}
	},
	data: function () {
		return {
			title: '',
			addHotelLocationButton: {
				label: '',
				progress: false,
				disabled: false
			},
			message: {
				type: null,
				text: null
			},
			messageHotelLocationsAdd: {
				type: null,
				text: null
			},
			messageHotelLocationsTable: {
				type: null,
				text: null
			},
			messageHotelLocationsRemove: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			mode_UNKNOWN0: 0,
			mode_NORMAL1: 1,
			mode: 0,
			newHotelLokacija: {
				id: 0,
				title: null
			},
			hotelLokacijeTable_props: {
				fields: [
					{ key: 'id', label: 'Št. lokacije', sortable: true, class: '' },
					{ key: 'title', label: 'Naziv', sortable: true, class: '' },
					{ key: 'status', label: 'Status', class: '' },
					{ key: 'actions', label: '#', sortable: false, class: '' }
				],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				page: 1,
				size: 10,
				total: 0,
				isLoading: false,
				inputFilter: {
					title: null
				},
				textFilterTimeout: null,
				options_numRowsOnPage: [
					{ value: 10, text: '10' },
					{ value: 50, text: '50' },
					{ value: 100, text: '100' }
				]
			}
		}
	},
	watch: {
	},
	computed: {
		state_title () {
			if (this.newHotelLokacija.title && this.newHotelLokacija.title.length > 0) {
				return true;
			}
			return false;
		},
		invalidFeedback_title () {
			if (this.newHotelLokacija.title && this.newHotelLokacija.title.length > 0) {
				return '';
			}
			return '';
		},
		hotelLokacijaAddTitle () {
			if (this.newHotelLokacija.title && this.newHotelLokacija.title.length > 0) {
				return 'Dodaj lokacijo';
			}
			return 'Naziv mora vsebovati vsaj en znak';
		},
		validateForm: function () {
			if (this.state_title) {
				return true;
			}
			return false;
		},
		formDisabled: function () {
			if (this.mode === this.mode_UNKNOWN0) {
				return true;
			}
			return false;
		},
		modalSize () {
			return 'lg'
		}
	},
	created () {
	}
}
</script>

<style scoped>
.ma_pos {
	text-align: end;
}
.table-responsive-sm {
	margin-bottom: 0;
}
.nav {
	border-top: 1px solid #c8ced3;
	padding-top: 1rem;
}
.pagination {
	margin-left: 1rem;
	margin-right: 1rem;
}
.page-link.rows_total {
	text-align: center;
	border-radius: 5px;
	width: 120px;
}
</style>
<style>

</style>


// WEBPACK FOOTER //
// src/components/HotelGum/Modals/HotelLokacijeModal.vue